// extracted by mini-css-extract-plugin
export default {"prizeDraw":"DrivingGlovesPrizeDraw__prizeDraw-Y7zV"};